import { GetterTree } from 'vuex';
import { TeamsState, Team } from './models';
import { RootState } from '@/store';

export enum Getters {
    TEAMS = 'TEAMS',
    LOADED = 'LOADED',
    SHORT_NAME = 'SHORT_NAME',
    ID = 'ID',
  }

export const getters: GetterTree<TeamsState, RootState> = {
  [Getters.TEAMS]({ teams }): Team[] {
    return teams;
  },
  [Getters.LOADED]({ loaded }): boolean {
    return loaded;
  },
  [Getters.SHORT_NAME]({ teams }) {
    return (teamId: number): string => {
      const team: Team = teams.filter((t) => t.id === teamId)[0];
      return team.shortName;
    };
  },
  [Getters.ID]({ teams }) {
    return (teamName: string): number | undefined => {
      const team: Team = teams.filter((t) => t.name.includes(teamName) ||
      t.shortName.includes(teamName) || t.shortcutName.includes(teamName) )[0];
      return team ?  team.id : undefined;
    };
  },
};
